import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const DeepLink = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { authData } = useSelector((state) => state.authReducer);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const type = params.get('type');
        const id = params.get('id');
        const tab = params.get('tab');
        const filter = params.get('filter');

        const deepLinkData = { type, id, tab, filter };
        sessionStorage.setItem('deepLinkIntent', JSON.stringify(deepLinkData));

        if (authData?.user) {
            dispatch({ type: "SET_DEEP_LINK_INTENT", payload: deepLinkData });
            navigate('/home');
        } else {
            navigate('/auth');
        }
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <p>Redirecting...</p>
        </div>
    );
};

export default DeepLink;